import React from "react";

export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      projects: "Projects",
      resume: "Resume",
      blogs: "Blogs",
    },
    home: {
      greeting: "Hi There!",
      iam: "I'M",
    },
    type: [
      "Backend Developer",
      "Java & Spring Boot Developer",
      "API Designer",
      "Database Manager (MySQL / Postgres / Oracle)",
      "Security & Logic Enthusiast",
      "Hibernate & JPA Specialist",
      "DevOps with Docker & CI/CD",
      "Software Deployment Strategist",
      "Productivity Tools Advocate",
    ],
    home2: {
      introTitle: (
        <>
          LET ME <span className="purple"> INTRODUCE </span> MYSELF
        </>
      ),
      aboutIntro: (
        <>
          I'm a <b className="purple">Backend Developer</b> specialized in
          <i>
            <b className="purple"> Java and Spring Boot</b>
          </i>
          , working with databases like
          <i>
            <b className="purple"> PostgreSQL and Oracle</b>
          </i>
          .
          <br />
          <br />
          I've delivered production software for real clients and participate in
          applied research on SDN network monitoring and real-time anomaly detection
          with the SEDNET Group.
          <br />
          <br />
          I use <b className="purple">Docker</b> and{" "}
          <b className="purple">GitHub Actions (CI/CD with Trivy and CodeQL)</b> and
          deploy on{" "}
          <b className="purple">AWS EC2, Render, Vercel and Kubernetes</b>.
          <br />
          <br />
          I also explore frontend technologies like{" "}
          <b className="purple">React.js</b> when needed.
        </>
      ),
      findMe: "FIND ME ON",
      connect: (
        <>
          Feel free to <span className="purple">connect</span> with me
        </>
      ),
    },
    about: {
      title: (
        <>
          Know Who <strong className="purple">I'M</strong>
        </>
      ),
      skills: (
        <>
          Professional <strong className="purple">Skillset </strong>
        </>
      ),
      tools: (
        <>
          <strong className="purple">Tools</strong> I use
        </>
      ),
    },
    github: {
      days: (
        <>
          Days I <strong className="purple">Code</strong>
        </>
      ),
    },
    projects: {
      title: (
        <>
          My Recent <strong className="purple">Works</strong>
        </>
      ),
      intro:
        "Here are some of the projects I've developed recently, showcasing my skills in React, Spring Boot, and API development.",
      p1: {
        title: "YourParking",
        description:
          "Parking lot management platform for a real client: space control, tickets, and automated billing with Mercado Pago. I increased space rotation by 40% and reduced manual billing errors by 95%. CI/CD with GitHub Actions, security scanning with Trivy and CodeQL, and Docker deployment.",
      },
      p2: {
        title: "SdnShare — SDN Network Monitoring",
        description:
          "Backend monitoring platform for Spine-Leaf SDN networks, developed in applied research with the SEDNET Group. DDoS anomaly detection engine with Spring WebFlux and real-time notifications via WebSocket, reducing detection latency from ~30 minutes to under 15 seconds. Centralized metrics with Prometheus and InfluxDB.",
      },
      p3: {
        title: "ClinCore — Medical Appointment Management",
        description:
          "Full-stack medical management system with 5 modules (patients, doctors, appointments, locations, users). REST API in Spring Boot 3 + Oracle DB, SPA in React 18 + Vite + Tailwind. JWT with refresh token and RBAC access control with 15+ granular permissions.",
      },
      p4: {
        title: "IoT Distributed Sensor System",
        description:
          "Distributed IoT system with Spring Boot 3 + Eclipse Paho MQTT, processing concurrent streams with thread-safe structures. 20+ REST endpoints documented with Swagger/OpenAPI, including SSE streaming. Deployed on Render + Vercel + Neon DB.",
      },
      p5: {
        title: "AlphaBrein",
        description:
          "Authentication platform (JWT + BCrypt) and chat with AI integration via n8n. Deployed with Docker, Kubernetes and full observability (Prometheus/Grafana).",
      },
    },
    aboutcard: {
      intro: (
        <>
          Hi, I'm <span className="purple">Breiner Saúl Martínez</span> from
          <span className="purple"> Cali, Valle del Cauca, Colombia.</span>
          <br />
          I'm a <b className="purple">Backend Developer</b> specialized in{" "}
          <b className="purple">Java and Spring Boot</b>, currently pursuing
          Systems Engineering at the Universidad Cooperativa de Colombia.
          <br />
          I've delivered production software for real clients — including a
          parking lot management platform with integrated payments — and I
          participate in applied research on SDN network monitoring and
          real-time anomaly detection with the SEDNET Group.
          <br />
          I work with{" "}
          <b className="purple">
            PostgreSQL, Oracle, Docker, GitHub Actions (CI/CD with Trivy and
            CodeQL)
          </b>{" "}
          and deploy on{" "}
          <b className="purple">AWS EC2, Render, Vercel and Kubernetes</b>.
          <br />
          <br />
          Apart from coding, I enjoy:
        </>
      ),
      items: [
        "Learning about new technologies",
        "Watching videos about computer science",
        "Listening to music",
      ],
      quote:
        "I build backend systems with purpose and logic, always aiming to improve people's lives through technology.",
    },
    resume: {
      download: "Download CV",
    },
    footer: {
      developed: "Designed and Developed by Breiner Martinez",
      copyright: "Copyright © {year} SB",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      about: "Acerca de",
      projects: "Proyectos",
      resume: "Hoja de vida",
      blogs: "Blogs",
    },
    home: {
      greeting: "¡Hola!",
      iam: "SOY",
    },
    type: [
      "Desarrollador Backend",
      "Desarrollador Java & Spring Boot",
      "Diseñador de APIs",
      "Gestor de Bases de Datos (MySQL / Postgres / Oracle)",
      "Entusiasta de la Seguridad y la Lógica",
      "Especialista en Hibernate y JPA",
      "DevOps con Docker y CI/CD",
      "Estratega de Despliegues de Software",
      "Impulsor de Herramientas de Productividad",
    ],
    home2: {
      introTitle: (
        <>
          DÉJAME <span className="purple"> PRESENTARME </span>
        </>
      ),
      aboutIntro: (
        <>
          Soy <b className="purple">Desarrollador Backend</b> especializado en
          <i>
            <b className="purple"> Java y Spring Boot</b>
          </i>
          , trabajando con bases de datos como
          <i>
            <b className="purple"> PostgreSQL y Oracle</b>
          </i>
          .
          <br />
          <br />
          He entregado software en producción para clientes reales y participo
          en investigación aplicada sobre monitoreo de redes SDN y detección de
          anomalías en tiempo real con el Grupo SEDNET.
          <br />
          <br />
          Uso <b className="purple">Docker</b> y{" "}
          <b className="purple">GitHub Actions (CI/CD con Trivy y CodeQL)</b> y
          despliego en{" "}
          <b className="purple">AWS EC2, Render, Vercel y Kubernetes</b>.
          <br />
          <br />
          También exploro tecnologías frontend como{" "}
          <b className="purple">React.js</b> cuando lo necesito.
        </>
      ),
      findMe: "ENCUÉNTRAME EN",
      connect: (
        <>
          Siéntete libre de <span className="purple">conectarte</span> conmigo
        </>
      ),
    },
    about: {
      title: (
        <>
          Conoce quién <strong className="purple">SOY</strong>
        </>
      ),
      skills: (
        <>
          <strong className="purple">Habilidades</strong> profesionales
        </>
      ),
      tools: (
        <>
          <strong className="purple">Herramientas</strong> que uso
        </>
      ),
    },
    github: {
      days: (
        <>
          Días que <strong className="purple">Codeo</strong>
        </>
      ),
    },
    projects: {
      title: (
        <>
          Mis <strong className="purple">Proyectos</strong> recientes
        </>
      ),
      intro:
        "Aquí hay algunos de los proyectos que he desarrollado recientemente, mostrando mis habilidades en React, Spring Boot y desarrollo de APIs.",
      p1: {
        title: "YourParking",
        description:
          "Plataforma de gestión de parqueaderos para un cliente real: control de espacios, tickets y cobro automatizado con Mercado Pago. Incrementé la rotación de espacios en 40% y reduje errores de facturación manual en 95%. CI/CD con GitHub Actions, escaneo de seguridad con Trivy y CodeQL, y despliegue con Docker.",
      },
      p2: {
        title: "SdnShare — Monitoreo de Redes SDN",
        description:
          "Plataforma de monitoreo backend para redes SDN Spine-Leaf, desarrollada en investigación aplicada con el Grupo SEDNET. Motor de detección de anomalías DDoS con Spring WebFlux y notificaciones en tiempo real vía WebSocket, reduciendo la latencia de detección de ~30 minutos a menos de 15 segundos. Métricas centralizadas con Prometheus e InfluxDB.",
      },
      p3: {
        title: "ClinCore — Gestión de Citas Médicas",
        description:
          "Sistema full-stack de gestión médica con 5 módulos (pacientes, médicos, citas, sedes, usuarios). API REST en Spring Boot 3 + Oracle DB, SPA en React 18 + Vite + Tailwind. JWT con refresh token y control de acceso RBAC con 15+ permisos granulares.",
      },
      p4: {
        title: "IoT Distributed Sensor System",
        description:
          "Sistema IoT distribuido con Spring Boot 3 + Eclipse Paho MQTT, procesando streams concurrentes con estructuras thread-safe. 20+ endpoints REST documentados con Swagger/OpenAPI, incluyendo streaming SSE. Desplegado en Render + Vercel + Neon DB.",
      },
      p5: {
        title: "AlphaBrein",
        description:
          "Plataforma de autenticación (JWT + BCrypt) y chat con integración de IA vía n8n. Desplegada con Docker, Kubernetes y observabilidad completa (Prometheus/Grafana).",
      },
    },
    aboutcard: {
      intro: (
        <>
          Hola, soy <span className="purple">Breiner Saúl Martínez</span> desde
          <span className="purple"> Cali, Valle del Cauca, Colombia.</span>
          <br />
          Soy <b className="purple">Desarrollador Backend</b> especializado en{" "}
          <b className="purple">Java y Spring Boot</b>, cursando Ingeniería de
          Sistemas en la Universidad Cooperativa de Colombia.
          <br />
          He entregado software en producción para clientes reales — incluyendo
          una plataforma de gestión de parqueaderos con pagos integrados — y
          participo en investigación aplicada sobre monitoreo de redes SDN y
          detección de anomalías en tiempo real con el Grupo SEDNET.
          <br />
          Trabajo con{" "}
          <b className="purple">
            PostgreSQL, Oracle, Docker, GitHub Actions (CI/CD con Trivy y
            CodeQL)
          </b>{" "}
          y despliego en{" "}
          <b className="purple">AWS EC2, Render, Vercel y Kubernetes</b>.
          <br />
          <br />
          Aparte de programar, disfruto:
        </>
      ),
      items: [
        "Aprender sobre nuevas tecnologías",
        "Ver videos sobre ciencias de la computación",
        "Escuchar música",
      ],
      quote:
        "Construyo sistemas backend con propósito y lógica, siempre buscando mejorar la vida de las personas a través de la tecnología.",
    },
    resume: {
      download: "Descargar CV",
    },
    footer: {
      developed: "Diseñado y desarrollado por Breiner Martinez",
      copyright: "Copyright © {year} SB",
    },
  },
};